import { Entity } from "../../api/entities/id-name";
import { IDeleteBlockedConfirmationData } from "../../components/buckets/dialogs/delete-blocked-confirmation/delete-blocked-confirmation";
import { DialogActions } from "./dialog";
import { ShardRepositoryListItem } from "../../api/entities/shard-repository";

const SHARD_REPOSITORY_ENTITY_NAME = 'shardRepository';

export const DELETE_CONFIRMATION_DIALOG_NAME = "deleteConfirmation";
export const DELETE_BLOCKED_CONFIRMATION_DIALOG_NAME = "deleteBlockedConfirmation";
export const UPDATE_CONFIRMATION_DIALOG_NAME = "updateConfirmation";

export const getShardRepositoryEntityName = () => SHARD_REPOSITORY_ENTITY_NAME;

class ShardRepositoryActions<TListItem extends Entity = ShardRepositoryListItem> {
    readonly entity;
    readonly deleteConfirmation;
    readonly deleteBlockedConfirmation;
    readonly updateConfirmation;

    constructor() {
        let entityName = SHARD_REPOSITORY_ENTITY_NAME;
        this.deleteConfirmation = new DialogActions<TListItem>(entityName, DELETE_CONFIRMATION_DIALOG_NAME);
        this.deleteBlockedConfirmation = new DialogActions<IDeleteBlockedConfirmationData>(entityName, DELETE_BLOCKED_CONFIRMATION_DIALOG_NAME);
        this.updateConfirmation = new DialogActions<TListItem>(entityName, UPDATE_CONFIRMATION_DIALOG_NAME);
    }
}

export const shardRepositoryActions = new ShardRepositoryActions();
